import React from 'react';
import InquiryForm from '../../inquiry/InquiryForm';

/**
 * 문의 작성 스크린 컴포넌트
 */
const InquiryCreateScreen = () => {
  return <InquiryForm />;
};

export default InquiryCreateScreen;